import { cn } from '@/utils/styles';

interface VideoPlayerProps extends React.ComponentProps<'video'> {
  videoSrc: string;
  className?: string;
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({
  videoSrc,
  className,
  ...videoProps
}) => {
  return (
    <div className={cn('relative overflow-hidden', className)}>
      <video
        className="w-full h-full object-cover"
        src={videoSrc}
        {...videoProps}
      />
    </div>
  );
};

export default VideoPlayer;
